export default function formatHotelRoomBed(room) {
  return (
    room?.bed?.nameWithPrice ??
    room?.bed?.name ??
    room?.bedChoices?.[0]?.name ??
    ''
  );
}
